import classNames from 'classnames'
import { useState } from 'react'

export interface RankTabProps {
  value: string
  name: string
}

export const RankTab: React.FC<{
  data: RankTabProps[]
  defaultIndex?: number
  className?: string
  onChange: (arg0: RankTabProps) => void
}> = ({ data, defaultIndex = 0, onChange, className }) => {
  const [currentIndex, setCurrentIndex] = useState(defaultIndex)

  return (
    <div className={classNames('flex justify-start', className)}>
      <div className="flex items-center p-1 border-2 border-neutral-300 rounded-[36px]">
        {data.map((item, index) => {
          const isActive = index === currentIndex
          return (
            <span
              key={item.name}
              className={classNames(
                'py-1.5 px-3 text-[14px] leading-4 font-semibold rounded-full cursor-pointer transition-all',
                [
                  isActive
                    ? 'text-neutral-800 bg-neutral-300'
                    : 'text-neutral-400 hover:text-neutral-800',
                ]
              )}
              onClick={() => {
                if (isActive) return
                setCurrentIndex(index)
                onChange(item)
              }}
            >
              {item.name}
            </span>
          )
        })}
      </div>
    </div>
  )
}
